import * as Styled from './social-proof-list.styles';

export const UserCardSkeleton: React.FC = () => (
  <Styled.SkeletonContainer>
    <Styled.SkeletonInfoWrapper>
      <Styled.SkeletonLogoImageContainer />
      <Styled.SkeletonUserInfo>
        {/* @ts-expect-error FIXME: SC6 */}
        <Styled.SkeletonTitleSkeleton size="small" amountRows={1} />
        {/* @ts-expect-error FIXME: SC6 */}
        <Styled.SkeletonBodySkeleton size="small" amountRows={2} />
      </Styled.SkeletonUserInfo>
    </Styled.SkeletonInfoWrapper>
  </Styled.SkeletonContainer>
);

export const SocialProofListSkeleton: React.FC<{ numberOfItems: number }> = ({
  numberOfItems,
}) => {
  const skeletons = Array.from({ length: numberOfItems }, (_, i) => (
    <Styled.ListItem key={i}>
      <UserCardSkeleton />
    </Styled.ListItem>
  ));

  return <>{skeletons}</>;
};
